/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-09-08T11:34:52+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-09-29T16:53:09+02:00
*/

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import inputGroupRadioProps from './inputGroupRadioProps';
import inputProps from './../../../utilities/inputProps';

/**
 * MInputGroupRadioText - groups radioboxes by passing them a name
**/

class MInputGroupRadioText extends Component {
  render() {
    const {
      error, // eslint-disable-line no-unused-vars
      disabled, // eslint-disable-line no-unused-vars
      children,
      groupName, // eslint-disable-line no-unused-vars
      onPress,
      visualState,
    } = this.props;

    return (
      <div
        onClick={onPress}
        className={`m-input m-input-group-radio-text ${visualState}`}
      >
        <div className="m-input-group-radio-text__radios">
          {children}
        </div>
      </div>
    );
  }
}

MInputGroupRadioText.propTypes = {
  /**
     * pass a group-name to group all inputs as one
     */
  groupName: PropTypes.string.isRequired,
  /**
     * show error state for all radiobuttons
     */
  error: PropTypes.bool,
  /**
     * disable whole selection
     */
  disabled: PropTypes.bool,
  /**
     * pass elements of AInputRadioText
     */
  children: PropTypes.any, // maped by inputGroupRadioProps
  /**
     * fired when the group was selected
     */
  onPress: PropTypes.any, // passed by inputProps
  /**
     * label
     */
  visualState: PropTypes.string, // passed by inputProps
};
MInputGroupRadioText.defaultProps = {};
export default inputProps(inputGroupRadioProps(MInputGroupRadioText));

